import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../../context/LoadingContext";
import NegotiateOffers from "./NegatiateOffers";
import ShortlistedOffers from "./ShortlistedOffers";
import AcceptedOffers from "./AcceptedOffers";
import BuyerActivityRFQs from "./RFQs";
import "../../../../styles/requirement.css";
import "../../../../styles/general.css";
import "../../../../styles/buyer.css";

const GpBuyerRfqOffers = () => {
  const [activeUser, setActiveUser] = useState("");
  const [activeTab, setActiveTab] = useState("RFQs");
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const tabs = [
    "RFQs",
    "Shortlisted Offers",
    "Negotiated Offers",
    "Accepted Offers",
  ];

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut();
          navigate("/login/global-partner");
        } else {
          setActiveUser(user.attributes.email);
        }
      } catch (error) {
        await Auth.signOut();
        navigate("/login/global-partner");
      }
    };
    checkUser();
  }, [navigate]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "RFQs":
        return <BuyerActivityRFQs />;
      case "Shortlisted Offers":
        return <ShortlistedOffers />;
      case "Negotiated Offers":
        return <NegotiateOffers />;
      case "Accepted Offers":
        return <AcceptedOffers />;
      default:
        return <BuyerActivityRFQs />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default GpBuyerRfqOffers;
